<ion-header>
    <ion-toolbar>
        <ion-title>{{title}}</ion-title>
        <ion-buttons slot="end">
            <ion-button [disabled]="!CanApply" (click)="OnApply()">
                <ion-icon slot="icon-only" name="checkmark-outline"></ion-icon>
            </ion-button>
            <ion-button (click)="OnClose()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="date-modal-body">
        <div class="manual-input-box">
            <ion-input
                [value]="dateText"
                [placeholder]="placeholder"
                inputmode="numeric"
                autocomplete="off"
                (ionInput)="OnDateTextChanged($event)"
            ></ion-input>
        </div>

        <div class="month-year-row">
            <upp-select [value]="currentMonth.toString()" (Changed)="OnMonthChanged($event)">
                <upp-select-item>
                    <ion-item lines="none">
                        <ion-label>{{MonthText(currentMonth)}}</ion-label>
                    </ion-item>
                </upp-select-item>
                <upp-select-list>
                    <upp-select-option *ngFor="let month of monthOptions" [value]="month.value.toString()">
                        <ion-item lines="none" button>
                            <ion-label>{{month.text}}</ion-label>
                        </ion-item>
                    </upp-select-option>
                </upp-select-list>
            </upp-select>

            <upp-select [value]="currentYear.toString()" (Changed)="OnYearChanged($event)">
                <upp-select-item>
                    <ion-item lines="none">
                        <ion-label>{{currentYear}}</ion-label>
                    </ion-item>
                </upp-select-item>
                <upp-select-list>
                    <upp-select-option *ngFor="let year of yearOptions" [value]="year.toString()">
                        <ion-item lines="none" button>
                            <ion-label>{{year}}</ion-label>
                        </ion-item>
                    </upp-select-option>
                </upp-select-list>
            </upp-select>

            <div class="month-nav-buttons">
                <ion-button fill="clear" size="small" (click)="OnPrevMonth()">
                    <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
                </ion-button>
                <ion-button fill="clear" size="small" (click)="OnNextMonth()">
                    <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
                </ion-button>
            </div>
        </div>

        <div class="calendar-box">
            <mat-calendar
                [selected]="calendarValue"
                [startAt]="activeDate || Today"
                [activeDate]="activeDate || Today"
                [minDate]="MinDate || undefined"
                [maxDate]="MaxDate || undefined"
                (selectedChange)="OnCalendarChanged($event)"
            ></mat-calendar>
        </div>
    </div>
</ion-content>
